import Vue from "vue";
import VueGtag from "vue-gtag";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { i18n } from "./i18n";

Vue.config.productionTip = false;

Vue.use(
  VueGtag,
  {
    config: { id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID },
    enabled:
      store.getters.googleCookie &&
      store.getters.privacyCookie === false &&
      process.env.NODE_ENV === "production"
        ? true
        : false,
    bootstrap:
      store.getters.googleCookie &&
      store.getters.privacyCookie === false &&
      process.env.NODE_ENV === "production"
        ? true
        : false,
    appName: "LivingEnergy",
  },
  router
);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
